import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from "react";
export var createSvgIcon = function createSvgIcon(_ref) {
  var Svg = _ref.svg,
      displayName = _ref.displayName;
  var Component = /*#__PURE__*/React.forwardRef(function Component(props, ref) {
    return /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.createElement(Svg, null), _objectSpread(_objectSpread({
      width: 24,
      height: 24
    }, props), {}, {
      ref: ref
    }));
  });
  Component.displayName = displayName;
  return Component;
};
//# sourceMappingURL=createSvgIcon.js.map